import React, { useEffect, useState, Fragment } from "react";
import Popup from "./Popup";
import Survey from "./Survey";
import OnePanelSurvey from "./OnePanelSurvey";
import Gatekeeper from "./Gatekeeper";
import axios from "axios";
import {
  SURVEY_CONTENT,
  ONE_PANEL_SURVEY_CONTENT,
  POPUP_CONTENT,
  GATEKEEPER_CONTENT,
  QUANTUM_METRICS_EVENT_LISTENERS,
} from "./constants";

function App() {
  const [surveys, setSurveys] = useState([]);
  const [onepanelsurveys, setOnePanelSurveys] = useState([]);
  const [popups, setPopups] = useState([]);
  const [gatekeepers, setGatekeepers] = useState([]);
  const script = document.createElement("script");

  //hooks version of componentsDidMount
  useEffect(() => {
    (async () => {
      script.async = true;
      script.type = "application/javascript";
      script.id = "baltoQmEvents";
      script.innerHTML = QUANTUM_METRICS_EVENT_LISTENERS;
      document.head.appendChild(script);
    })();

    (async () => {
      try {
        const { data } = await axios({
          method: "GET",
          auth: {
            username: KONG_API_USERNAME,
            password: KONG_API_PASSWORD,
          },
          responseType: 'json',
          url: `${KONG_API_URL}/cms/getEntryPoint`,
          params: {
            url: window.location,
          },
        });
        // Temp until KONG API issue is resolved
        let responseData;
        if (data.data === undefined) {
          responseData = data;
        } else {
          responseData = JSON.parse(data.data);
        }

        const { content_definition, code } = responseData;

        if (code) {
          console.log(`Balto error: ${code}`);
        } else if (content_definition) {
          setSurveys(
            content_definition.filter(
              (content) =>
                Object.prototype.hasOwnProperty.call(content, SURVEY_CONTENT) &&
                Object.keys(content[SURVEY_CONTENT]).length > 0
            )
          );

          setOnePanelSurveys(
            content_definition.filter(
              (content) =>
                Object.prototype.hasOwnProperty.call(
                  content,
                  ONE_PANEL_SURVEY_CONTENT
                ) && Object.keys(content[ONE_PANEL_SURVEY_CONTENT]).length > 0
            )
          );

          setPopups(
            content_definition.filter(
              (content) =>
                Object.prototype.hasOwnProperty.call(content, POPUP_CONTENT) &&
                Object.keys(content[POPUP_CONTENT]).length > 0
            )
          );

          setGatekeepers(
            content_definition.filter(
              (content) =>
                Object.prototype.hasOwnProperty.call(
                  content,
                  GATEKEEPER_CONTENT
                ) && Object.keys(content[GATEKEEPER_CONTENT]).length > 0
            )
          );
        }
      } catch (e) {
        console.log(e);
      }
    })();
  }, []);

  return (
    <Fragment>
      <div data-testid={"App"} className={"balto"}>
        {surveys.map((survey, i) => (
          <Survey key={`survey${i}`} definition={survey} />
        ))}
        {onepanelsurveys.map((onepanelsurvey, i) => (
          <OnePanelSurvey
            key={`onepanelsurvey${i}`}
            definition={onepanelsurvey}
          />
        ))}
        {popups.map((popup, i) => (
          <Popup key={`popup${i}`} definition={popup} />
        ))}
        {gatekeepers.map((gatekeeper, i) => (
          <Gatekeeper key={`gatekeeper${i}`} definition={gatekeeper} />
        ))}
      </div>
    </Fragment>
  );
}

export default App;
